module.exports = __webpack_public_path__ + "static/assets/2edf2ba7cc4f481e9f09f0354860836b.png";